var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-content',{staticClass:"pt-0"},[_c('v-content',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h1',{staticClass:"mb-2 display-1 text-center"},[_vm._v("404 Nie ma takiej strony")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }